// Servicios.js
import React from 'react';
import { FiCompass, FiDroplet, FiActivity, FiMap, FiTool, FiTruck, FiCheck } from 'react-icons/fi';

const servicios = [
  {
    titulo: 'Ingeniería y Proyectos',
    icon: FiCompass,
    items: [
      'Proyectos de arquitectura e ingeniería civil, eléctrica, mecánica e industrial',
      'Cálculo de estructuras y asesoramiento técnico',
      'Estudios, planos de ingeniería y topografía',
      'Inspección y control de obras'
    ]
  },
  {
    titulo: 'Construcción y Procesamiento de Crudo',
    icon: FiDroplet,
    items: [
      'Construcción de plantas de procesamiento de crudo y estaciones de flujo',
      'Fabricación de oleoductos, gaseoductos y tanques de almacenamiento',
      'Instalación de calentadores de crudo y centros de control de motores',
      'Montaje electromecánico industrial'
    ]
  },
  {
    titulo: 'Servicios Petroleros',
    icon: FiActivity,
    items: [
      'Perforación, estimulación, rehabilitación y control de pozos',
      'Registros eléctricos y fluidos de perforación',
      'Evaluación y control de pozos',
      'Saneamiento ambiental, segado de fosas y biodegradación'
    ]
  },
  {
    titulo: 'Obras Civiles y Vialidad',
    icon: FiMap,
    items: [
      'Movimiento de tierras, locaciones y canalizaciones',
      'Vialidad, asfaltado y señalización civil',
      'Construcción de puentes y obras civiles e industriales',
      'Mantenimiento de áreas verdes y ornamentales'
    ]
  },
  {
    titulo: 'Metalurgia y Estructuras',
    icon: FiTool,
    items: [
      'Construcción mecánica, metalmecánica e hidráulica',
      'Soldadura, plomería y herrería en general',
      'Fabricación de piezas de hierro, acero y aluminio',
      'Instalación de cercas de ciclón y hierro forjado'
    ]
  },
  {
    titulo: 'Transporte y Logística',
    icon: FiTruck,
    items: [
      'Transporte de equipos industriales, maquinaria y mercancía',
      'Transporte lacustre de personas y equipos',
      'Alquiler de maquinarias y equipos industriales',
      'Importación y distribución de materiales y herramientas'
    ]
  }
];

const Servicios = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container-page">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">Qué ofrecemos</p>
          <h1 className="section-title">Nuestros Servicios</h1>
        </div>

        <div className="space-y-10">
          {servicios.map((servicio, index) => (
            <article
              key={servicio.titulo}
              className="grid md:grid-cols-2 gap-8 lg:gap-12 items-stretch rounded-3xl bg-white shadow-card p-6 md:p-10"
            >
              <div
                className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-700 to-primary-900 min-h-[240px] flex items-center justify-center ${
                  index % 2 === 1 ? 'md:order-2' : ''
                }`}
              >
                <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, #ffffff 1.5px, transparent 1.5px)', backgroundSize: '22px 22px' }}></div>
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-accent-500/20"></div>
                <div className="relative flex flex-col items-center text-center px-6">
                  <servicio.icon className="w-20 h-20 text-white/90 mb-4" />
                  <span className="text-4xl font-bold text-white/10 font-display">0{index + 1}</span>
                </div>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <servicio.icon className="w-6 h-6" />
                  </div>
                  <h2 className="text-2xl font-semibold">{servicio.titulo}</h2>
                </div>
                <ul className="space-y-2.5">
                  {servicio.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-slate-600">
                      <FiCheck className="w-4 h-4 text-accent-500 mt-1 shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicios;
